import React, { memo, useEffect, useRef } from 'react';
import { useJackpotsForGame } from '@homeplay/hooks';
import classes from './JackpotGameFrameLabels.module.scss';
import { formatBalance } from '@homeplay/utils';
import CountUp from 'react-countup';
import grandLabel from '../../../../../shared/assets/images/jackpot/grand-label.png';
import majorLabel from '../../../../../shared/assets/images/jackpot/major-label.png';
import minorLabel from '../../../../../shared/assets/images/jackpot/minor-label.png';

export const JACKPOT_SLUG = {
  GRAND: 'grand',
  MAJOR: 'major',
  MINOR: 'minor',
};

const JackpotCounter = memo(({ balance = 0 }) => {
  const previousBalanceRef = useRef(balance);
  const hasMountedRef = useRef(false);

  useEffect(() => {
    hasMountedRef.current = true;
    previousBalanceRef.current = balance;
  }, [balance]);

  const getStartValue = () => {
    const previous = Number(previousBalanceRef.current) || 0;
    const current = Number(balance) || 0;
    
    if (current < previous) {
      return 0;
    }
    
    if (previous === current) {
      return hasMountedRef.current ? current : Math.max(0, current - 50);
    }
    return Math.max(0, previous);
  };

  return (
    <CountUp
      start={getStartValue()}
      end={balance || 0}
      duration={30}
      preserveValue
      formattingFn={(v) => formatBalance(v)}
    />
  );
});

// TODO: never rendered, jackpot_lifecycles[].games is always empty (see useJackpotsForGame)
const JackpotGameFrameLabels = ({ gameSlug }) => {
  const { jackpotsForGame } = useJackpotsForGame(gameSlug);
  if (!jackpotsForGame?.length) return null;

  const getLabelImage = (slug) => {
    const key = String(slug || '').toLowerCase();
    if (key === JACKPOT_SLUG.MAJOR) return majorLabel;
    if (key === JACKPOT_SLUG.GRAND) return grandLabel;
    if (key === JACKPOT_SLUG.MINOR) return minorLabel;
    return null;
  };
  return (
    <div className={classes.Root} data-slug={gameSlug}>
      {jackpotsForGame.map((jp) => (
        <div
          key={jp.slug}
          className={classes.CounterWrapper}
          data-variant={jp.slug}
        >
          {jp.winnerName ? (
            <span className={classes.Winner}>
              Jackpot won by {jp.winnerName}
            </span>
          ) : (
            <>
              {getLabelImage(jp.slug) ? (
                <img
                  className={classes.Label}
                  src={getLabelImage(jp.slug)}
                  alt={`${String(jp.slug || '').toUpperCase()} JACKPOT`}
                />
              ) : (
                <span className={classes.Winner}>{jp.slug.toUpperCase()}</span>
              )}
              <span className={classes.Amount}>
                <JackpotCounter balance={jp.balance} />
              </span>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default memo(JackpotGameFrameLabels);


